module.exports = __webpack_public_path__ + "media/images/application/template/email-footer-86f2008812d770cccb595448bd789552.jpg";